import {Divider, MenuItem, Typography} from "@material-ui/core";
import React, {useEffect, useRef, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import classNames from 'classnames';
import {useDispatch, useSelector} from "react-redux";
import {getOrdensParaCorte, postCortePrintEtiqueta, postCorteRespostas} from "../../../actions/orderActions";
import {getItemCodigoBarras} from "../../../actions/tireActions";
import {getRandomInt} from "../../../utils/utils";
import ZebraBrowserPrint from "./ZebraBrowserPrint";
import {isValid, parseISO} from "date-fns";
import format from "date-fns/format";
import Menu from "@material-ui/core/Menu/Menu";

const useStyles = makeStyles(theme => ({
    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 12,
        backgroundColor: 'white',
        margin: '6px',
        borderRadius: '15px',
        minHeight: '180px'
    },
    jaCortada: {
      backgroundColor: 'green'
    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignSelf: 'stretch',
        cursor: 'pointer'
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
         alignSelf: 'center',
        borderBottom: '1px solid red'
    },
    valoresArea: {
        //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    resize:{
        fontSize:36
    },
    tituloGrid: {
        justifyContent: 'center'

    },

}));


const CorteOS = (props) => {
    const classes = useStyles();
    const { ordemServico } = props;
    const dispatch = useDispatch();
    const itemCodigoBarras = useSelector(state =>   state.tires.itemCodigoBarras.data);
    const [bandaSelecionada, setBandaSelecionada] = useState('');
    const [ligacao, setLigacao] = useState('');
    const [ligacaoSelecionada, setLigacaoSelecionada] = useState('');
    const [codValidacao, setCodValidacao] = useState(getRandomInt(100,999));
    const [dtInicio, setDTInicio] = useState( '');
    const [banda, setBanda] = useState();
    const [tfBanda, setTFBanda] = useState('');
    const [tfNSBanda, setTFNSBanda] = useState('');
    const [tfLigacao, setTFLigacao] = useState('');
    const [tfloteLigacao, setLoteLigacao] = useState('');
    const inputRef = useRef();
    const inputRef2 = useRef();



    //var bp = null;

    // useEffect(() => {
    //     const script = document.createElement('script');
    //
    //     script.src = "https://use.typekit.net/foobar.js";
    //     script.async = true;
    //
    //     document.body.appendChild(script);
    //
    //     bp = BrowserPrint;
    //
    //     return () => {
    //         document.body.removeChild(script);
    //     }
    // }, []);


    useEffect( () => {
        const di = new Date().toISOString();
        setBandaSelecionada('');
        setTFBanda('');
        setBanda(null);
        setLigacao(null);
        setTFLigacao('');
        setCodValidacao(getRandomInt(100,999));
        setDTInicio(di);


    }, [ordemServico.os]);


    const dialog = (os) => {
        props.cbOpenCorte(os,false);
        //alert(os);
    }

    const handleKeyDown = (event) => {
        console.log("handleKeydown", event.key);
        if (event.key === 'Enter') {
            // valida na lista
            const cb = itemCodigoBarras.find(f => f.codigoBarras === tfBanda);
            if (!cb) {
                setBanda(null);
                //alert("Codigo sem relacionamento com banda");
                setBandaSelecionada("Item nao cadastrado");

            } else {
                //alert("codigo barras encontrado:" + JSON.stringify(cb,null,4));
                inputRef.current.focus();
                setBanda(cb.id);
                const d = cb.banda? cb.banda.descricao : "";
                setBandaSelecionada(cb.descricao + " [" + d +"]");
            }

        }
    }

    const handleKeyDownLigacao = (event) => {
        console.log("handleKeydownLigacao", event.key);
        if (event.key === 'Enter') {
            // valida na lista
            const cb = itemCodigoBarras.find(f => f.codigoBarras === tfLigacao);
            if (!cb) {
                setLigacao(null);
                setLigacaoSelecionada("Item nao cadastrado!");

            } else {
                //alert("codigo barras encontrado:" + JSON.stringify(cb,null,4));
                inputRef2.current.focus();
                setLigacao(cb.id);

                setLigacaoSelecionada(cb.descricao );
            }

        }
    }

    const handleBanda = (e) =>{
        console.log("handleBanda", e);
        setTFBanda(e);
    }

    const handleLoteLigacao = (e) => {
        setLoteLigacao(e);
    }

    const handleSave = async () => {
       const x = await dispatch(postCorteRespostas(ordemServico, tfBanda, banda? banda.id : 0,tfNSBanda, codValidacao, dtInicio, new Date().toISOString(), tfloteLigacao, tfLigacao) );
       const y = await dispatch(postCortePrintEtiqueta(ordemServico, codValidacao));
        props.cbOpenCorte(ordemServico, false);
    }





    // console.log("CorteOS ", ordemServico,tfBanda, );
    if (!ordemServico || !ordemServico.os) { return <React.Fragment/>}

    console.log("ordemServico", ordemServico);

    const tchegada = (new Date(new Date().getTime() - new Date(ordemServico.DTChegada).getTime()) );
    // onClick={() => dialog(ordemServico)}
    return (
        <React.Fragment>

            <Grid container className={classes.gridExterno}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item className={classes.nomeEtapa} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h1">{ordemServico.os.toUpperCase()}</Typography>

                    </Grid>
                    <Grid container item className={classes.valoresArea} xs={4} sm={4} md={4} lg={4} xl={4}>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>MEDIDA</Typography>
                            <Typography  style={{fontSize: '1.6rem'}}>{ordemServico.medida}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>BANDA</Typography>
                            <Typography  style={{fontSize: '1.6rem'}}>{ordemServico.banda}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>LARGURA</Typography>
                            <Typography  style={{fontSize: '1.6rem'}}>{ordemServico.largura}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>COMPRIMENTO:</Typography>
                            <Typography  style={{fontSize: '1.6rem'}}>{ordemServico.perimetro}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>TEMPO NA FILA:</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{renderMilisecondsToTimeDuration(tchegada)}</Typography>
                        </ListItem>

                    </Grid>
                    <Grid container item className={classes.valoresArea} xs={8} sm={8} md={8} lg={8} xl={8}>

                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>CODIGO EAN DA BANDA:</Typography>
                            <TextField  InputProps={{
                                classes: {
                                    input: classes.resize,
                                },
                            }} required fullWidth onChange={(event) => setTFBanda(event.target.value)}  onKeyDown={handleKeyDown} id="cbBanda" label="" value={tfBanda} />
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>BANDA:</Typography>
                            <Typography  style={{fontSize: '1.5rem'}}>{bandaSelecionada}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>NUM LOTE BANDA:</Typography>
                            <TextField  InputProps={{
                                classes: {
                                    input: classes.resize,
                                },

                            }} required fullWidth  inputRef={inputRef} id="scannerNumSerieBanda"
                                        onChange={(event) => setTFNSBanda(event.target.value)}
                                        label=""  id="cbNSBanda"
                                        value={tfNSBanda} />
                        </ListItem>
                        <Divider/>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>EAN LIGACAO:</Typography>
                            <TextField  InputProps={{
                                classes: {
                                    input: classes.resize,
                                },
                            }} required fullWidth
                                        onChange={(event) => setTFLigacao(event.target.value)}
                                        onKeyDown={handleKeyDownLigacao}
                                        id="cbLigacao" label=""
                                        value={tfLigacao} />

                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>LIGAÇÃO:</Typography>
                            <Typography  style={{fontSize: '1.5rem'}}>{ligacaoSelecionada}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>LOTE LIGAÇÃO:</Typography>
                            <TextField  InputProps={{
                                classes: {
                                    input: classes.resize,
                                },

                            }} required fullWidth
                                        inputRef={inputRef2} id="scannerLoteLigacao"
                                        onChange={(event) => handleLoteLigacao(event.target.value)}
                                        label=""  id="loteLigacao"
                                        value={tfloteLigacao} />
                        </ListItem>
                        <Divider/>


                        {(tfBanda.length > 4) && (tfNSBanda.length > 4) &&

                            <React.Fragment>
                                <ListItem style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Typography style={{fontSize: '0.8rem'}}>COD VALIDACAO:</Typography>
                                    <Typography style={{fontSize: '2rem'}}>Escreva esse código na banda
                                        => {codValidacao}</Typography>
                                </ListItem>



                                <ListItem>
                                    <Grid container style={{flex:1, alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                                    <Button onClick={handleSave}>Salvar</Button>
                                    </Grid>
                                </ListItem>
                            </React.Fragment>
                        }

                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}

export default CorteOS;
